export enum UploadFlows {
  UPLOAD_NEW = 'upload-new',
  DATA_PORTAL = 'data-portal',
}
